export const plantData = {
    rose: {
        name: 'Rose',
        images: [
            '/images/plants/rose1.png',
            '/images/plants/rose2.png',
            '/images/plants/rose3.png',
            '/images/plants/rose4.png',
            '/images/plants/rose5.png',
        ],
        growthThresholds: [0, 2, 5, 9, 14], // Points needed to reach each image stage
    },
    sunflower: {
        name: 'Sunflower',
        images: [
            '/images/plants/sunflower1.png',
            '/images/plants/sunflower2.png',
            '/images/plants/sunflower3.png',
            '/images/plants/sunflower4.png',
        ],
        growthThresholds: [0, 3, 7, 12],
    },
    cactus: {
        name: 'Cactus',
        images: [
            '/images/plants/cactus1.png',
            '/images/plants/cactus2.png',
            '/images/plants/cactus3.png',
        ],
        growthThresholds: [0, 4, 8],
    },
    tulip: {
        name: 'Tulip',
        images: [
            '/images/plants/tulip1.png',
            '/images/plants/tulip2.png',
            '/images/plants/tulip3.png',
        ],
        growthThresholds: [0, 2, 5],
    },
    orchid: {
        name: 'Orchid',
        growthTime: 20,
        stages: 4,
        images: [
            '/images/plants/orchid1.png',
            '/images/plants/orchid2.png',
            '/images/plants/orchid3.png',
            '/images/plants/orchid4.png',
        ],
        growthThresholds: [0, 5, 10, 15],
    },
    bonsai: {
        name: 'Bonsai Tree',
        growthTime: 30,
        stages: 6,
        images: [
            '/images/plants/bonsai1.png',
            '/images/plants/bonsai2.png',
            '/images/plants/bonsai3.png',
            '/images/plants/bonsai4.png',
            '/images/plants/bonsai5.png',
            '/images/plants/bonsai6.png',
        ],
        growthThresholds: [0, 5, 10, 15, 20, 30],
    }
};
export default plantData;